import React from "react";
import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import useFetchObjects from "../../api/useFetchObjects";
import { useAuth } from "../../context/AuthContext";

const MyShopEmployees = () => {
  const auth = useAuth();
  const token = auth?.user?.token || auth?.user?.access;
  const { data, isLoading, isError } = useFetchObjects(
    ["my-shop-employees"],
    "shop/employees/my-shop/",
    token
  );

  const employees = data?.results || data || [];

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return <Alert severity="error">Unable to load employees for this shop.</Alert>;
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Tazkira ID</TableCell>
            <TableCell>Contact</TableCell>
            <TableCell>Salary</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {employees.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4}>
                <Typography color="text.secondary">
                  No employees belong to your shop yet.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            employees.map((employee) => (
              <TableRow key={employee.id}>
                <TableCell>{employee.name || "--"}</TableCell>
                <TableCell>{employee.tazkira_id || "--"}</TableCell>
                <TableCell>{employee.contact || "--"}</TableCell>
                <TableCell>{employee.salary || "--"}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MyShopEmployees;
